/**
 * Есть ли элеменит в коллекции
 * @param collection
 * @param elem
 */
function collectionHas(collection, elem) {
  for (let i = 0, len = collection.length; i < len; i++) {
    if (collection[i] == elem) return true;
  }
  return false;
}

/**
 * Поиск родителя элемента по селектору
 * @param elem
 * @param selector
 */
export function findClosestElemBySelector(elem, selector) {
  let all = document.querySelectorAll(selector);
  let cur = elem;
  while(cur && !collectionHas(all, cur)) {
    cur = cur.parentNode;
  }
  return cur;
}
